import { useEffect } from 'react'
import { sendPostMessage } from 'gatsby-theme-marketplace-base/src/utils/postMessage/utils'
import { PM_EVENT } from 'gatsby-theme-marketplace-base/src/utils/postMessage/constants'

export default ({ items }) => {
  useEffect(() => {
    sendPostMessage(PM_EVENT.BREADCRUMBS, {
      items,
    })
  }, [items])

  return null
}
